const SERVER_URL = 'http://webdav-elb-81217841.us-east-1.elb.amazonaws.com/DAV/';
// export const SERVER_URL = 'http://localhost:8181/DAV/';

const initialPos = -1;

const BrowsersOptions = {
  IE: { Search: 'MSIE', Browser: 'IE' },
  IE11: { Search: 'Trident/7', Version: 'rv', Browser: 'IE' },
  Edge: { Search: 'Edge', Browser: 'Edge' },
  FF: { Search: ['Firefox', 'FxiOS'], Browser: 'FF' },
  Electron: { Search: 'Electron', Browser: 'Electron' },
  Chrome: { Search: 'Chrome', Browser: 'Chrome' },
  Safari: {
    Search: 'Safari',
    Version: 'Version',
    Browser: 'Safari',
    Mac: 'Macintosh',
    iPad: 'iPad',
    iPhone: 'iPhone',
  },
  Opera: { Search: 'Opera', Browser: 'Opera' },
};

const browsersDetection = {
  IE: false,
  FF: false,
  Chrome: false,
  Safari: false,
  Opera: false,
  Electron: false,
  Browser: null,
  Mac: false,
  iPad: false,
  iPhone: false,
};
const DevicesOptions = {
  Android: { Search: 'Android' },
  BlackBerry: { Search: 'BlackBerry' },
  iOS: { Search: 'iPhone|iPad|iPod' },
  Opera: { Search: 'Opera Mini' },
  Windows: { Search: 'IEMobile' },
  Mobile: {}
};
const DevicesFound = {
  Android: false,
  BlackBerry: false,
  iOS: false,
  Opera: false,
  Windows: false,
  Mobile: false
};

const extencions = {
  Access: ['accdb', 'mdb'],
  Infopath: ['xsn', 'xsf'],
  Excel: ['xltx', 'xltm', 'xlt', 'xlsx', 'xlsm', 'xlsb', 'xls', 'xll', 'xlam', 'xla', 'ods'],
  Powerpoint: ['pptx', 'pptm', 'ppt', 'ppsx', 'ppsm', 'pps', 'ppam', 'ppa', 'potx', 'potm', 'pot', 'odp'],
  Project: ['mpp', 'mpt'],
  Publisher: ['pub'],
  Visio: ['vstx', 'vstm', 'vst', 'vssx', 'vssm', 'vss', 'vsl', 'vsdx', 'vsdm', 'vsd', 'vdw'],
  Word: ['docx', 'doc', 'docm', 'dot', 'dotm', 'dotx', 'odt'],
};
const filesPrefix = {
  Access: 'ms-access',
  Infopath: 'ms-infopath',
  Project: 'ms-project',
  Publisher: 'ms-publisher',
  Visio: 'ms-visio',
  Word: 'ms-word',
  Powerpoint: 'ms-powerpoint',
  Excel: 'ms-excel'
};

export const DetectBrowser = (function DetectBrowser() {
  const { userAgent } = navigator;

  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const browserConfigKey in BrowsersOptions) {
    let pos = initialPos;
    const browserConfig = BrowsersOptions[browserConfigKey];
    if (Array.isArray(browserConfig.Search)) {
      for (let i = 0; i < browserConfig.Search.length; i += 1) {
        pos = userAgent.indexOf(browserConfig.Search[i]);
        if (pos !== initialPos) {
          break;
        }
      }
    } else {
      pos = userAgent.indexOf(browserConfig.Search);
    }
    if (pos !== initialPos) {
      browsersDetection.Browser = browserConfig.Browser;
      browsersDetection.Mac = navigator.platform.indexOf('Mac') === 0;
      browsersDetection.iPad = userAgent.indexOf(browserConfig.iPad) !== initialPos;
      browsersDetection.iPhone = userAgent.indexOf(browserConfig.iPhone) !== initialPos;
      const search = Array.isArray(browserConfig.Search)
        ? browserConfig.Search[0]
        : browserConfig.Search;
      const versionOrSearch = browserConfig.Version || search;
      const indexVersionDetected = userAgent.indexOf(versionOrSearch);
      if (indexVersionDetected !== initialPos) {
        // @ts-ignore
        browsersDetection[browserConfig.Browser] = true;
        break;
      }
      // @ts-ignore
      browsersDetection[browserConfig.Browser] = parseFloat(
        userAgent.substring(indexVersionDetected + versionOrSearch.length + 1)
      );
      break;
    }
  }
  return browsersDetection;
}());
export const DetectDevice = (function DetectDevice() {
  const { userAgent } = navigator;
  // eslint-disable-next-line no-restricted-syntax,guard-for-in
  for (const divicesOptionsKey in DevicesOptions) {
    const divicesOption = DevicesOptions[divicesOptionsKey];
    if (!divicesOption.Search) {
      // eslint-disable-next-line no-continue
      continue;
    }
    const regExp = new RegExp(divicesOption.Search, 'i');
    DevicesFound[divicesOptionsKey] = regExp.test(userAgent);
    if (!DevicesFound.Mobile && DevicesFound[divicesOptionsKey]) {
      DevicesFound.Mobile = true;
    }
  }
  return DevicesFound;
}());

export const DetectOS = (function DetectOs() {
  const isMacIntel = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
  const { platform } = navigator;
  const OSDetected = {
    Windows: platform.indexOf('Win') !== initialPos,
    MacOS: platform.indexOf('Mac') !== initialPos,
    IOS: /iPad|iPhone|iPod/.test(platform) || isMacIntel,
    Linux: platform.indexOf('Linux') !== initialPos,
    UNIX: platform.indexOf('X11') !== initialPos,
    OS: null
  };
  if (OSDetected.Windows) {
    OSDetected.OS = 'Windows';
  } else if (OSDetected.Linux) {
    OSDetected.OS = 'Linux';
  } else if (OSDetected.IOS) {
    OSDetected.OS = 'IOS';
  } else if (OSDetected.MacOS) {
    OSDetected.OS = 'MacOS';
  } else if (OSDetected.UNIX) {
    OSDetected.OS = 'UNIX';
  }
  return OSDetected;
}());

const getMSSchema = (fileExtencion) => {
  let filePrefix = null;
  const prefixKeys = Object.keys(filesPrefix);
  const extension = fileExtencion.toLowerCase();
  for (let i = 0, l = prefixKeys.length; i < l; i += 1) {
    const prefix = prefixKeys[i];
    // @ts-ignore
    const extenciones = extencions[prefix];
    for (let j = 0, m = extenciones.length; j < m; j += 1) {
      if (extenciones[j] === extension) {
        // @ts-ignore
        filePrefix = filesPrefix[prefix];
        break;
      }
    }
    if (filePrefix !== null) {
      break;
    }
  }
  return filePrefix;
};

const getExtension = (fileUrl) => {
  let url = fileUrl;
  const parametersIndex = url.indexOf('?');
  if (parametersIndex > -1) {
    url = url.substr(0, parametersIndex);
  }
  const aExt = url.split('.');
  if (aExt.length === 1) {
    const aExtFull = fileUrl.split('.');
    if (aExtFull.length === 1) {
      return null;
    }
    return aExtFull.pop();
  }
  return aExt.pop();
};

export const isMicrosoftOfficeDocument = (fileUrl) => {
  const sExt = getExtension(fileUrl);
  if (!sExt) {
    return false;
  }
  return getMSSchema(sExt) != null;
};

export const getUrlEditDocument = (fileUrl, filename = undefined) => {
  const ext = getExtension(filename || fileUrl);
  if (!ext || ext === '') {
    return null;
  }
  if (!isMicrosoftOfficeDocument(filename || fileUrl)) {
    return null;
  }
  const urlPrefix = (DetectOS.OS === 'MacOS') ? encodeURIComponent('ofe|u|') : 'ofe|u|';
  return `${getMSSchema(ext)}:${urlPrefix}${SERVER_URL}${fileUrl}`;
};
